module.exports = __webpack_public_path__ + "f47a941d1d8fd02fefbbdf295b52508f.jpg";